var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0006 18.1256V27.1256C34.0006 27.424 33.8821 27.7101 33.6711 27.9211C33.4601 28.1321 33.174 28.2506 32.8756 28.2506H23.8756C23.5773 28.2506 23.2911 28.1321 23.0801 27.9211C22.8692 27.7101 22.7506 27.424 22.7506 27.1256C22.7506 26.8273 22.8692 26.5411 23.0801 26.3301C23.2911 26.1192 23.5773 26.0006 23.8756 26.0006H30.1602L19.3756 15.2161L14.5466 20.0466C14.4421 20.1512 14.318 20.2341 14.1814 20.2908C14.0449 20.3474 13.8985 20.3765 13.7506 20.3765C13.6028 20.3765 13.4564 20.3474 13.3198 20.2908C13.1832 20.2341 13.0592 20.1512 12.9547 20.0466L2.82969 9.92156C2.61859 9.71047 2.5 9.42416 2.5 9.12563C2.5 8.82709 2.61859 8.54078 2.82969 8.32969C3.04078 8.11859 3.32709 8 3.62563 8C3.92416 8 4.21047 8.11859 4.42156 8.32969L13.7506 17.6602L18.5797 12.8297C18.6842 12.7251 18.8082 12.6421 18.9448 12.5855C19.0814 12.5289 19.2278 12.4997 19.3756 12.4997C19.5235 12.4997 19.6699 12.5289 19.8064 12.5855C19.943 12.6421 20.0671 12.7251 20.1716 12.8297L31.7506 24.4102V18.1256C31.7506 17.8273 31.8692 17.5411 32.0801 17.3301C32.2911 17.1192 32.5773 17.0006 32.8756 17.0006C33.174 17.0006 33.4601 17.1192 33.6711 17.3301C33.8821 17.5411 34.0006 17.8273 34.0006 18.1256Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoss);
export default __webpack_public_path__ + "static/media/loss.a9636ce2be74ff2d77f2dc68ffee4a12.svg";
export { ForwardRef as ReactComponent };